export const statusArray = ['Aguardando Aprovação', 'Em Análise', 'Aprovado', 'Em Produção', 'Enviado', 'Finalizado', 'Cancelado', 'Reprovado']

export const statusConfig = {
  'Aguardando Aprovação': {
    color: 'yellow',
    description: 'Pedido aguardando aprovação do cliente',
  },
  'Em Análise': {
    color: 'blue',
    description: 'Pedido em análise pela equipe técnica',
  },
  Aprovado: {
    color: 'green',
    description: 'Pedido aprovado e pronto para produção',
  },
  'Em Produção': {
    color: 'purple',
    description: 'Pedido está sendo produzido',
  },
  Enviado: {
    color: 'teal',
    description: 'Pedido já foi enviado ao cliente',
  },
  Finalizado: {
    color: 'green',
    description: 'Pedido finalizado com sucesso',
  },
  Cancelado: {
    color: 'red',
    description: 'Pedido foi cancelado',
  },
  Reprovado: {
    color: 'red',
    description: 'Pedido foi reprovado por algum motivo',
  },
}

// Função para obter a cor correta com base no status
export function getStatusColor(status) {
  return statusConfig[status]?.color || 'gray'
}
